import { Card, Form, Input } from 'antd';
import FormItem from 'components/form/FormItem';
import { get } from 'lodash';
import { useTranslation } from 'react-i18next';

export default function RefundInformation() {
  const { t } = useTranslation();
  return (
    <Card title={t('ordersReturn.refund')} className="w-full h-full">
      <FormItem
        name="paymentType"
        label={t('ordersReturn.refundMethod')}
        disbaled
      />
      <Form.Item
        noStyle
        shouldUpdate={(o, n) => get(o, 'paymentType') !== get(n, 'paymentType')}
      >
        {({ getFieldValue }) => {
          const paymentType = getFieldValue('paymentType');
          const isShow = paymentType === 'bank' || paymentType === 'cod';
          return (
            <>
              <FormItem
                name="bankName"
                label={t('ordersReturn.bank.label')}
                placeholder={t('ordersReturn.bank.placeholder')}
                required={isShow}
                disbaled={!isShow}
              />
              <FormItem
                name="bankAccountName"
                label={t('ordersReturn.accountName.label')}
                placeholder={t('ordersReturn.accountName.placeholder')}
                required={isShow}
                disbaled={!isShow}
              />
              <FormItem
                name="bankAccountNumber"
                label={t('ordersReturn.accountNumber.label')}
                placeholder={t('ordersReturn.accountNumber.placeholder')}
                required={isShow}
                disbaled={!isShow}
              />
              <FormItem
                name="refundDescription"
                label={t('ordersReturn.description.label')}
                placeholder={t('ordersReturn.description.placeholder')}
                disbaled={!isShow}
              >
                <Input.TextArea disabled={!isShow} />
              </FormItem>
            </>
          );
        }}
      </Form.Item>
    </Card>
  );
}
